var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialVksvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_874_11870)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1471 1.26008C15.2576 0.92061 15.1471 0.673504 14.6545 0.673504H13.0179C12.605 0.673504 12.4147 0.88982 12.3034 1.12114C12.3034 1.12114 11.4611 3.09956 10.2855 4.38166C9.90421 4.75272 9.72974 4.87587 9.52368 4.87587C9.41237 4.87587 9.26947 4.75272 9.26947 4.41245V1.24508C9.26947 0.842452 9.14237 0.657715 8.79263 0.657715H6.21895C5.96474 0.657715 5.80605 0.843241 5.80605 1.02877C5.80605 1.41561 6.39342 1.50798 6.45737 2.58956V4.93824C6.45737 5.44824 6.36263 5.54061 6.15579 5.54061C5.59921 5.54061 4.24921 3.54719 3.43921 1.27587C3.27895 0.827452 3.12105 0.657715 2.70816 0.657715H1.05579C0.579737 0.657715 0.5 0.874031 0.5 1.10614C0.5 1.52298 1.05579 3.62456 3.08947 6.40587C4.43947 8.30693 6.36184 9.32693 8.09395 9.32693C9.14237 9.32693 9.26947 9.09482 9.26947 8.70877V7.27193C9.26947 6.80772 9.36421 6.73035 9.69816 6.73035C9.93658 6.73035 10.3653 6.85429 11.3347 7.76614C12.4463 8.84772 12.6374 9.34193 13.2563 9.34193H14.8929C15.3697 9.34193 15.5916 9.10982 15.4645 8.66219C15.3224 8.21377 14.7816 7.56482 14.0829 6.79193C13.7016 6.35929 13.1292 5.88087 12.9547 5.64877C12.7163 5.34008 12.7803 5.21614 12.9547 4.93824C12.9389 4.93824 14.9403 2.18771 15.1471 1.26008Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_874_11870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 8.68421,
    fill: "white",
    transform: "translate(0.5 0.657715)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialVksvg);
export default __webpack_public_path__ + "static/media/social-vk.svg.26077d9eae7bbafa062c2cc961f18272.svg";
export { ForwardRef as ReactComponent };